import { I18n } from '@calendly/i18n';
import { CheckboxField } from '@calendly/ui/form/checkbox-field';
import classNames from 'classnames';
import { useCallback, useContext, forwardRef } from 'react';
import ItemContext from './item_context';
import { MenuActionItem } from './styles';
export const LabelName = ({
  name,
  isDeleted
}) => isDeleted ? I18n.t('publisher.scheduled_events.filters.deleted_item', {
  name
}) : name;
const eventTypeCheckboxFieldIsDeletedCss = "e271cp8";
const eventTypeCheckboxFieldCss = "e12ihbt1";
const EventTypeCheckboxField = forwardRef((props, ref) => {
  const {
    isDeleted,
    ...restProps
  } = props;
  return <CheckboxField ref={ref} {...restProps} className={classNames(eventTypeCheckboxFieldCss, {
    [eventTypeCheckboxFieldIsDeletedCss]: isDeleted
  }, props.className)} />;
});
export default function Item({
  className,
  item,
  value = false,
  onChange
}) {
  const {
    LabelComponent
  } = useContext(ItemContext);
  const Label = useCallback(() => <LabelComponent item={item}>
      <LabelName name={item.name} isDeleted={item.deleted} />
    </LabelComponent>, [item]);
  if (!item) {
    return null;
  }
  return <MenuActionItem className={className}>
      <EventTypeCheckboxField isDeleted={item.deleted} label={<Label />} disabled={item.disabled} checked={value} onChange={onChange} />
    </MenuActionItem>;
}

require("./item.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./item.js");